import useAuth from "../../hooks/authenticate/useAuth";
import useConfig from "../../hooks/useConfig";
// import ChartsToday from "./EilatContainer/ChartsToday";
// import EilatGouge from "./EilatContainer/EilatGouge";
import EilatGougeAndChartToday from "./EilatContainer/EilatGougeAndChartToday";
import EilatReports from "./EilatContainer/EilatReports";
const EilatContainer = () => {
  const { config } = useConfig();
  const { auth } = useAuth();

  return (
    <div className="w-full h-full flex flex-col items-center justify-evenly p-4 shadow-xl  backdrop-blur-xl  bg-blue-900 bg-opacity-30  rounded-xl ">
      <section className="w-full ">
        <EilatGougeAndChartToday token={auth.token} areas={config.areas} />
      </section>
      {/* <div className=" w-full h-full mt-2 flex shadow-md rounded-xl bg-white   "> */}
        {/* <EilatReports /> */}
      {/* </div> */}
    </div>
  );
};
export default EilatContainer;
